module.exports = __webpack_public_path__ + "media/images/flags/16/Kosovo-a3c8a2e119cc33c81f5576d2e5620dab.png";